export const DEFAULT_LANGUAGE = 'it'
